<template>
  <span>
    <b-tabs
      v-if="showFileUpload"
      v-model="tabIndex"
    >
      <b-tab :title="$t('Single')">
        <validation-observer ref="simpleRules">
          <b-form>

            <!-- The Date -->
            <b-form-group
              :label="$t('The Date')"
              label-for="mc-the-date"
            >
              <validation-provider
                #default="{ errors }"
                name="The Date"
                rules="required"
              >
                <flat-pickr
                  v-model="item.theDate"
                  class="form-control"
                  :state="errors.length > 0 ? false:null"
                  :config="{ enableTime: false,dateFormat: 'Y-m-d'}"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Description -->
            <b-form-group
              label="Description"
              label-for="mc-description"
            >
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-input
                  v-model="item.description"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Description"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

          </b-form>
        </validation-observer>
      </b-tab>
      <b-tab
        :title="$t('Multi')"
      >

        <p><b-link @click="downloadCurrent">Download Holidays</b-link></p>
        <validation-observer ref="simpleRules2">
          <b-form>

            <!-- Holiday File -->
            <b-form-group
              label="Holiday File"
              label-for="holiday_file"
            >
              <b-form-file
                id="holiday_file"
                v-model="holiday_file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>

          </b-form>
        </validation-observer>

      </b-tab>

    </b-tabs>
    <validation-observer
      v-else
      ref="simpleRules"
    >
      <b-form>

        <!-- The Date -->
        <b-form-group
          :label="$t('The Date')"
          label-for="mc-the-date"
        >
          <validation-provider
            #default="{ errors }"
            name="The Date"
            rules="required"
          >
            <flat-pickr
              v-model="item.theDate"
              class="form-control"
              :state="errors.length > 0 ? false:null"
              :config="{ enableTime: false,dateFormat: 'Y-m-d'}"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Description -->
        <b-form-group
          label="Description"
          label-for="mc-description"
        >
          <validation-provider
            #default="{ errors }"
            name="Description"
            rules="required"
          >
            <b-form-input
              v-model="item.description"
              :state="errors.length > 0 ? false:null"
              placeholder="Description"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

      </b-form>
    </validation-observer>

  </span>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BTabs, BTab, BFormFile, BLink,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BTabs,
    BTab,
    BFormFile,
    BLink,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    showFileUpload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabIndex: 0,
      defaultItem: {
        theDate: new Date(),
        description: null,
      },
      required,
      holiday_file: null,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  methods: {
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    downloadCurrent() {
      useJwt.axiosIns.get('holiday/downloadCurrentHolidays', { params: { } })
        .then(response => {
          if (response.data) {
            this.openFile(response, 'holidays.csv')
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    validationForm() {
      if (this.tabIndex === 0) {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            if (this.item.id) {
              useJwt.axiosIns.patch('holiday', this.item)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            } else {
              useJwt.axiosIns.post('holiday', this.item)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            }
          }
        })
      } else {
        this.$refs.simpleRules2.validate().then(success => {
          if (success && this.holiday_file) {
            const formData = new FormData()
            formData.append('HolidayFile', this.holiday_file)

            useJwt.axiosIns.post('holiday/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              .then(response => {
                if (response.data) {
                  if (response.data === 'Ok') {
                    this.$emit('submit')
                  } else {
                    this.$emit('error', response.data)
                  }
                  this.holiday_file = null
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            this.$emit('error', 'Select a file!')
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
